<template>
    <div class="page-wrapper">
        <div class="page-inner bg-brand-gradient">
            <div class="page-content-wrapper bg-transparent m-0">
                <!-- LoginNav -->
                <LoginNav page="login"/>
                <div class="flex-1" style="background: url(img/svg/pattern-1.svg) no-repeat center bottom fixed; background-size: cover;">
                    <div class="container py-4 py-lg-5 my-lg-5 px-4 px-sm-0">
                        <div class="row">
                            <div class="col col-md-6 col-lg-7 hidden-sm-down">
                                <h2 class="fs-xxl fw-500 mt-4 text-white">
                                    Social Intelligence
                                    <small class="h3 fw-300 mt-3 mb-5 text-white opacity-60">
                                        Permite la Inteligencia Social mediante la escucha activa de múltiples medios y la generación de información para la toma de decisiones.
                                    </small>
                                    <small class="h3 fw-300 mt-3 mb-5 text-white opacity-60">
                                        Integra fuentes dispares en un repositorio de Big Data desde redes sociales, páginas web, foros, blogs, radio o TV, para ser analizados de manera sencilla usando un potente motor analítico.
                                    </small>
                                </h2>
                                <div class="d-sm-flex flex-column align-items-center justify-content-center d-md-block">
                                    <div class="px-0 py-1 mt-5 text-white fs-nano opacity-50">
                                        Síguenos
                                    </div>
                                    <div class="d-flex flex-row opacity-70">
                                        <a href="#" class="mr-2 fs-xxl text-white">
                                            <i class="fab fa-facebook-square"></i>
                                        </a>
                                        <a href="#" class="mr-2 fs-xxl text-white">
                                            <i class="fab fa-twitter-square"></i>
                                        </a>
                                        <a href="#" class="mr-2 fs-xxl text-white">
                                            <i class="fab fa-google-plus-square"></i>
                                        </a>
                                        <a href="#" class="mr-2 fs-xxl text-white">
                                            <i class="fab fa-linkedin"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-5 col-xl-4 ml-auto">
                                <h1 class="text-white fw-300 mb-3 d-sm-block d-md-none">
                                    Secure login
                                </h1>
                                <div class="card p-4 rounded-plus bg-faded">
                                    <form id="js-login" novalidate="" @submit.prevent="login">
                                        <div class="form-group">
                                            <label class="form-label" for="username">Correo Electrónico</label>
                                            <input type="email" id="username" v-model="username" class="form-control form-control-lg" placeholder="Tu Correo Electrónico" required>
                                            <div class="invalid-feedback">No, you missed this one.</div>
                                            <div class="help-block">Tu Correo Electrónico</div>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-label" for="password">Tu Contraseña</label>
                                            <input type="password" id="password" v-model="password" class="form-control form-control-lg" placeholder="Tu Contraseña" required>
                                            <div class="invalid-feedback">Sorry, you missed this one.</div>
                                            <div class="help-block">Tu Contraseña</div>
                                        </div>
                                        <div class="form-group text-left">
                                            <div class="custom-control custom-checkbox">
                                                <input type="checkbox" class="custom-control-input" id="rememberme">
                                                <label class="custom-control-label" for="rememberme"> Recordarme por 30 días</label>
                                            </div>
                                        </div>
                                        <div class="row no-gutters">
                                            <div class="col-lg-6 pl-lg-1 my-2">
                                                <button id="js-login-btn" type="submit" class="btn btn-danger btn-block btn-lg">Iniciar Sesión</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <!-- LoginFooter -->
                        <LoginFooter />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LoginNav from "@/components/login/LoginNav.vue";
import LoginFooter from "@/components/login/LoginFooter.vue";
import JQuery from 'jquery';
import login from "@/api/modules/login";

export default {
    data() {
        return {
        username: null,
        password: null
        };
    },
    components:{
        LoginNav,
        LoginFooter
    },
    methods: {
        login: function () {
            const { username, password } = this
            login.apiLogin(username, password)
            .catch((err)=>{
                console.log(err);
            })
        }
    },
    mounted(){
        JQuery("#js-login-btn").click(function(event)
            {

                // Fetch form to apply custom Bootstrap validation
                var form = JQuery("#js-login")

                if (form[0].checkValidity() === false)
                {
                    event.preventDefault()
                    event.stopPropagation()
                }

                form.addClass('was-validated');
                // Perform ajax submit here...
            });
    }
}
</script>
